import { Component, OnInit, Input, Output, EventEmitter, ViewChild } from '@angular/core';
import { UtilityService } from '../../../services/utilities/utilities.services';
import { MatPaginator } from '@angular/material';

@Component({
  selector: 'hybse-admin-pagination',
  templateUrl: './pagination.component.html',
  styleUrls: ['./pagination.component.css']
})
export class PaginationComponent implements OnInit {
  pages: number = 5;
  pageNumber: number;
  currentIndex: number = 1;
  pagesArray: Array<number>;
  pageStart: number = 1;
  pageSize: number = 50;
  data = {
    pageIndex: 0,
    pageSize: this.pageSize
  }
  // pageCounts: number[] = [5, 10, 20];
  pageCount: number;

  constructor() { }
  @ViewChild(MatPaginator) paginator: MatPaginator
  @Output('page')
  pageEmitter: EventEmitter<object> = new EventEmitter<object>();

  @Input('count')
  set page(count) {

    this.pageCount = count;
    this.pageNumber = Math.ceil((this.pageCount) / this.pageSize);

    if(count ==undefined){
      this.paginator._pageIndex=0;
    }
    //  count;
    if (this.pageNumber < 5) {
      this.pages = this.pageNumber;
    }
    this.pagesArray = this.setPageIndex();
  }

  ngOnInit() {

  }


  setPageIndex(): any {
    var pagesIndexArray = new Array();
    for (var index = this.pageStart; index < this.pageStart + this.pages; index++) {
      pagesIndexArray.push(index);
    }
    return pagesIndexArray;
  }

  firstPage() {
    // this.currentIndex = 1;
    this.pageStart = 1;
    this.data.pageIndex = this.currentIndex - 1;
    this.pagesArray = this.setPageIndex();
    this.pageEmitter.emit(this.data);
  }

  LastPage() {
    this.currentIndex = this.pageNumber;
    this.pageStart = this.currentIndex;
    this.data.pageIndex = this.currentIndex - 1;
    this.pagesArray = this.setPageIndex();
    this.pageEmitter.emit(this.data);
  }

  prevPage() {
    if (this.currentIndex > 0) {
      this.currentIndex--;
    }
    if (this.currentIndex < this.pageStart) {
      if (this.currentIndex == 0) {
        this.pageStart = ++this.currentIndex;
      }
      this.pageStart = this.currentIndex;
    }
    this.data.pageIndex = this.currentIndex - 1;
    this.pagesArray = this.setPageIndex();
    this.pageEmitter.emit(this.data);
  }

  nextPage() {
    if (this.currentIndex < this.pageNumber) {
      this.data.pageIndex = this.currentIndex++;
    }
    if (this.currentIndex >= (this.pageStart + this.pages)) {
      this.pageStart = this.currentIndex - this.pages + 1;
    }
    this.pagesArray = this.setPageIndex();
    this.pageEmitter.emit(this.data);
  }

  setPage(index: number) {
    this.currentIndex = index;
    this.data.pageIndex = this.currentIndex - 1;
    this.pagesArray = this.setPageIndex();
    this.pageEmitter.emit(this.data);
  }

  setPageCount(pageCount) {
    this.pages = Math.ceil((this.pageCount) / pageCount);
    this.data.pageSize = pageCount;
    this.pagesArray = this.setPageIndex();
    this.pageEmitter.emit(this.data);
  }

  paginateContent(event) {
    this.data.pageIndex = event.pageIndex;
    this.data.pageSize = event.pageSize;
    this.pageEmitter.emit(this.data);
  }
}



// WEBPACK FOOTER //
// /home/vatzcar/public_html/BEX-KYC-Admin/src/app/components/common/pagination/pagination.component.ts